import React from "react";
import { useTranslation } from "react-i18next";

/**
 * v0.4.22 — Settings page UI primitives extracted so subtabs can
 * import them as a single small module instead of redefining them
 * inline (and so Settings.jsx stays under the 400-LOC cap).
 */

export const Section = ({ titleKey, title, icon, children }) => {
  const { t } = useTranslation();
  return (
    <section className="border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
      <div className="border-b border-slate-200 dark:border-slate-700 px-4 py-2 flex items-center gap-2 text-xs tracking-normal text-slate-500 dark:text-slate-400">
        {icon} {titleKey ? t(titleKey) : title}
      </div>
      <div className="p-4 space-y-3">{children}</div>
    </section>
  );
};

export const Field = ({ labelKey, label, children }) => {
  const { t } = useTranslation();
  return (
    <label className="grid grid-cols-12 gap-3 items-center">
      <span className="col-span-3 text-xs text-slate-600 dark:text-slate-300">{labelKey ? t(labelKey) : label}</span>
      <div className="col-span-9">{children}</div>
    </label>
  );
};

export const Input = (p) => (
  <input {...p} className="w-full bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-slate-50 px-3 py-2 text-sm rounded-xl" />
);
